import { AddUserSuggestion } from 'globalTypes'

import styles from './index.module.css'

const Suggestion = ({ email, name, picture }: AddUserSuggestion) => (
  <span className={styles.container}>
    <img alt={name} className={styles.img} src={picture} />
    <div className={styles.text}>
      <div className="font-medium">{name}</div>
      <div className="text-xs">{email}</div>
    </div>
  </span>
)

export default Suggestion
